import React, {useState} from "react";
import {CircularProgress} from "@material-ui/core";
import "./payment.css"
import {useTranslation} from 'react-i18next';
import TextField from "@material-ui/core/TextField";

const PopSMSPaymentCheckout = (props) => {
    const {
        setModal, modal, handlePayBySMS, isLoading, setCouponInput
    } = props;

    const [buttonDisabled, setButtonDisabled] = useState(true);

    const closeModal = () => {
        setModal({
            show: false,
            data: null,
        })
    }

    const {t} = useTranslation();

    const handleChange = (e) => {
        setCouponInput(e.target.value.toUpperCase());
        if (e.target.value.length === 6) {
            setButtonDisabled(false)
        } else {
            setButtonDisabled(true)
        }
    }

    return (
        <div
            className={modal.show ? "modalPayment active" : "modalPayment"} onClick={closeModal}>
            <div className={'modal-content-payment'}
                 onClick={e => e.stopPropagation()}>
                <div className={'close-and-feedback'}>
                    <div className={'leave-feedback'}>
                        <span>{t('pay-by-sms')}</span>
                    </div>
                    <div className={'close-button'}>
                        <svg width="30" height="17" className={'close_icon'}
                             onClick={closeModal}
                             viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.6416 12.0002L18.5804 7.07632C19.0069 6.61883 18.9948 5.90538 18.5522 5.46381C18.1097 5.0213 17.3972 5.00819 16.9397 5.43475L12.0001 10.3586L7.07621 5.42731C6.62059 4.96982 5.88089 4.96792 5.4234 5.42356C4.96591 5.87824 4.96402 6.61888 5.41965 7.07636L10.3584 12.0002L5.41965 16.924C4.9931 17.3815 5.00527 18.095 5.44778 18.5366C5.89029 18.9791 6.60278 18.9922 7.06029 18.5656L11.9841 13.6418L16.908 18.5656H16.9089C17.3617 19.0269 18.1033 19.0344 18.5655 18.5806C19.0267 18.1278 19.0342 17.3862 18.5805 16.9241L13.6416 12.0002Z"
                                fill="#003E47" fillOpacity="0.4"/>
                        </svg>
                    </div>
                </div>
                {/*<h5 style={{textAlign: "left", margin: "unset", color: "#475569"}}> {t('coupon')}</h5>*/}
                <div>
                    <div style={{paddingBottom: "10px"}}>{t('sms-top.sending-sms-to', {number: 8866})}</div>
                    <strong>INZERIO</strong>
                    <div style={{paddingTop: "10px"}}>{t('sms-top.you-will-receive', {price: 1.3})}</div>
                </div>
                <div>
                    <TextField fullWidth={true}
                               variant="outlined"
                               id="coupon code"
                               autoComplete={'one-time-code'}
                               autoFocus={true}
                               inputProps={{ style: { textTransform: "uppercase" } }}
                               onChange={handleChange}
                               label={t('coupon')}/>
                </div>

                {/*<h5 style={{textAlign: "left", margin: "unset", color: "#475569"}}> {t('card-expiration')}</h5>*/}
                {/*<div style={{border: '1px solid #475569',  borderRadius :"0.3rem", padding: "0.5rem 0.5rem"}}>*/}
                {/*    <CardExpiryElement options={cardElementOptions}/>*/}
                {/*</div>*/}

                {/*<h5 style={{textAlign: "left", margin: "unset", color: "#475569"}}>{t('CVC')}</h5>*/}
                {/*<div style={{border: '1px solid #475569',  borderRadius :"0.3rem",  padding: "0.5rem 0.5rem"}}>*/}
                {/*    <CardCvcElement options={cardElementOptions}/>*/}
                {/*</div>*/}

                <form onSubmit={handlePayBySMS}>
                    <button type="submit" className={'payCard'} disabled={buttonDisabled}>
                        {isLoading ? <CircularProgress size={20}/> : t('sms-top.use-coupon')}
                    </button>
                </form>
                {/*<div>*/}
                {/*    <Link to={'/terms-of-use'} className={'more-info'}>Viac info o platbe mobilom</Link>*/}
                {/*</div>*/}
            </div>
        </div>
    )
}
export default PopSMSPaymentCheckout